export * from '@discoverer/fuse/services/tailwind/public-api';
